<span class="text-proffeo-muted text-sm">
  {{ 'task-details-modal-changed-estimated-time' | translate }} :
  {{ $safeNavigationMigration(activity()?.data?.to) | intlDuration }}
</span>
